import { render, staticRenderFns } from "./sentencingRegister.vue?vue&type=template&id=7e3b0eaf&scoped=true"
import script from "./sentencingRegister.vue?vue&type=script&lang=js"
export * from "./sentencingRegister.vue?vue&type=script&lang=js"
import style0 from "./sentencingRegister.vue?vue&type=style&index=0&id=7e3b0eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3b0eaf",
  null
  
)

export default component.exports